import React, { Component } from 'react';
import './index.css';

import { useNavigate } from "react-router-dom";
import { useAuth } from 'fennec-ui';

 // or 'antd/dist/antd.less'

import locale from 'antd/es/date-picker/locale/ru_RU';
import {
  Form,
  Input,
  Select,
  Button,
  message,
  Card,
  Alert
} from 'antd';

function ResetPassword(props) {
  let navigate = useNavigate();
  const auth = useAuth();
  const formRef = React.createRef();

  const [password, setPassword] = React.useState("")
  const [confirmDirty, setConfirmDirty] = React.useState(false)
  const [error, setError] = React.useState({ error: false, message: "" })

  React.useEffect(() => {
    var nurl = new URL(window.location.href);
    var token = nurl.searchParams.get("token");
    auth.fetch('/api/reset-password-valid?token=' + token).then(res => {
      if (!res || !res.status) {
        setError({ error: true, message: res.message })
      }
    });
  }, [])

  const handleSubmit = React.useCallback((values) => {
    auth.resetPassword(values)
      .then(res => {
        if (!res.status) {
          //Валидация (подумать как сделать универсально)
          //Чистим ошибки предыдущей валидации
          formRef.current.setFieldsValue(formRef.current.getFieldsValue());
          //Показываем новые ошибки
          if (res.invalid && res.invalid.errors) {
            var object = res.invalid.errors
            for (const key in object) {
              if (object.hasOwnProperty(key)) {
                const element = object[key];
                if (element && element.length) {
                  var valData = [];
                  valData.push({
                    name: key,
                    errors: [element[0].message],
                    value: (element[0].value) ? element[0].value : ""
                  })
                  formRef.current.setFields(valData);
                }
              }
            }
          }

          setError({ error: true, message: res.message })
        } else {
          window.location.href = auth.schemhttp + "://" + auth.getDomainWithoutSubdomain(window.location.href);
        }
      })
      .catch(err => {
        console.log(err)
      })
  }, [formRef])

  const handleConfirmBlur = (e) => {
    const { value } = e.target;
    setConfirmDirty(confirmDirty || !!value);
  };

  const formItemLayout = {
    labelCol: {
      xs: { span: 24 },
      sm: { span: 8 },
    },
    wrapperCol: {
      xs: { span: 24 },
      sm: { span: 16 },
    },
  };
  const tailFormItemLayout = {
    wrapperCol: {
      xs: {
        span: 24,
        offset: 0,
      },
      sm: {
        span: 16,
        offset: 8,
      },
    },
  };

  return (
    <div style={{
      height: "calc(100vh - 12px)",
      backgroundColor: (props.mobile) ? "white" : "#f5f5f5",
      margin: "5px",
      borderRadius: "5px"
    }}>

      <div className="register-form" style={{ paddingBottom: "0px", textAlign: "center", maxWidth: (props.mobile) ? "300px" : "600px" }}>
        <a href={auth.schemhttp + "://" + auth.getDomainWithoutSubdomain(window.location.href)}>
          <img style={{ height: "70px" }} src="/resources/logo-blue.svg" alt="Logo" />
        </a>
      </div>

      {!error.error && <Form ref={formRef} name="resetPassword" {...formItemLayout}
        onFinish={handleSubmit}
        onFinishFailed={({ errorFields }) => {
          formRef.current.scrollToField(errorFields[0].name);
        }}
        className="register-form"
        style={{ maxWidth: (props.mobile) ? "300px" : "600px", paddingTop: "5px" }}

        initialValues={{
          genderID: '1',
          tipTelefonaID: '1',
        }}
      >
        <div style={{
          backgroundColor: "white",
          padding: (props.mobile) ? "0px" : "25px",
          boxShadow: "1px 1px 8px 0px rgba(34, 60, 80, 0.2)",
          borderRadius: "5px"
        }}>

          <Form.Item label="Новый пароль" hasFeedback
            name="password"
            rules={[
              {
                required: true,
                message: 'Пожалуйста, введите пароль не меньше 8 символов!',
              },
              {
                min: 8,
                message: 'Пожалуйста, введите пароль не меньше 8 символов!',
              },
            ]}
          >
            <Input.Password />
          </Form.Item>
          <Form.Item label="Повторите пароль" hasFeedback
            name="confirm"
            dependencies={['password']}
            rules={[
              {
                required: true,
                message: 'Пожалуйста, повторите ваш пароль!',
              },
              {
                min: 8,
                message: 'Пожалуйста, повторите ваш пароль!',
              },
              ({ getFieldValue }) => ({
                validator(rule, value) {
                  if (!value || getFieldValue('password') === value) {
                    return Promise.resolve();
                  }
                  return Promise.reject('Пароли не совпадают!');
                },
              }),
            ]}
          >
            <Input.Password onBlur={handleConfirmBlur} />
          </Form.Item>

          <Form.Item {...tailFormItemLayout}>
            <Button type="primary" htmlType="submit">
              Изменить
            </Button>
          </Form.Item>
        </div>
      </Form>}
      {error.error && <div className="register-form">
        <Card>
          <Alert
            message="Ошибка изменения пароля"
            description={error.message}
            type="error"
            showIcon
          />
          <div style={{ paddingTop: "25px" }}>
            <a href="/login">Вернуться на страницу входа</a>
          </div>
        </Card>
      </div>}
    </div>
  );
}

export default ResetPassword;